module.exports = __webpack_public_path__ + "media/logo-vista-small.19aeb86d.svg";